import { render, staticRenderFns } from "./QuestionnaireStats.vue?vue&type=template&id=59e81774&scoped=true&"
import script from "./QuestionnaireStats.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireStats.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireStats.vue?vue&type=style&index=0&id=59e81774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e81774",
  null
  
)

/* custom blocks */
import block0 from "./QuestionnaireStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports